import React from 'react';
import { useTab } from '@/hooks/tab';
import { Tab } from '@/types/hashes';
import Item from '@/components/organisms/section/Item';
import Order from '@/components/organisms/section/Order';
import { EmailView, IdView, PhoneNumberView } from '@/components/organisms/section/Client';
import styles from './Section.module.scss';

const View: React.FC = () => {
  const [tab] = useTab();

  const getTabContentComp = () => {
    switch (tab) {
      case Tab.ITEM:
        return <Item />;
      case Tab.ORDER:
        return <Order />;
      case Tab.EMAIL:
        return <EmailView />;
      case Tab.LOGIN_ID:
        return <IdView />;
      case Tab.PHONE_NUMBER:
        return <PhoneNumberView />;
      default:
        return <></>;
    }
  };

  return (
    <div
      className={styles.container}
      data-cy={`PageContent-${tab}`}
    >
      <div className={styles.wrapper}>{getTabContentComp()}</div>
    </div>
  );
};

export default View;
